import { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Lang from "../Utils/lang";
import style from "./Users.module.scss";
import { getData } from "../Services/getData";
import { enumUrl } from "../Utils/utils";
import AddNewUser from "./AddNewUser";
import DeleteUser from "./DeleteUser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

let lang = Lang.getInstance();

const Users = () => {
  const [users, setUsers] = useState([]);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);
  const [requestedData, setRequestedData] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [loading, setLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const notifyError = (message) => toast.error(message);

  useEffect(() => {
    if (!requestedData) {
      setLoading(true);
      onGetUsers();
      setRequestedData(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestedData]);

  /**
   *
   * @param {*} index
   * @param {*} id
   * @param {*} username
   * @param {*} organization
   * @param {*} organizationBreak
   * @param {*} userBreak
   * @param {*} role
   * @returns
   */
  function createData(index, id, name, username, roles) {
    return { index, id, name, username, roles };
  }

  /**
   *
   */
  async function onGetUsers() {
    setLoading(true);
    let url = `${enumUrl.user}`;
    const token = localStorage.getItem("access_token");
    await getData(url, {
      Headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        let tableData = [];
        response.data.forEach((value, key) => {
          tableData.push(
            createData(
              key + 1,
              value.id,
              value.name,
              value.username,
              value.roles
            )
          );
        });
        setUsers(tableData);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        notifyError(
          `${lang.get("errorGettingData")}: ${err.response.statusText}`
        );
      });
  }

  /**
   *
   */
  const handleOpenAddUserModal = async () => {
    setShowAddUserModal(true);
    setSelectedRow(null);
  };
  /**
   *
   */
  const handleCloseAddUserModal = () => {
    setShowAddUserModal(false);
  };

  /**
   *
   * @param {*} row
   */
  const onDeleteUser = async (row) => {
    setDeleteId(row.id);
    setShowDeleteUserModal(true);
  };

  /**
   *
   * @param {*} row
   */
  const onEditUser = async (row) => {
    setSelectedRow(row);
    setShowAddUserModal(true);
  };

  return (
    <>
      <div className={style.container}>
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, marginRight: 6, color: "white" }}>
            <Button
              variant="outlined"
              className={style.addUser}
              onClick={handleOpenAddUserModal}
            >
              Utilizator nou
            </Button>
          </Box>
          <div className={style.userContainer}>
            <TableContainer
              style={{ maxHeight: "750px", overflow: "auto" }}
              component={Paper}
            >
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow className={style.openUser}>
                    <TableCell style={{ color: "white" }}>Nr.</TableCell>
                    <TableCell style={{ color: "white" }}>Nume</TableCell>
                    <TableCell style={{ color: "white" }}>
                      Nume utilizator
                    </TableCell>
                    <TableCell style={{ color: "white" }}>Rol</TableCell>
                    <TableCell
                      style={{
                        float: "right",
                        marginRight: 30,
                        color: "white",
                      }}
                    >
                      Opțiuni
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((row) => (
                    <TableRow key={row.id} sx={{}}>
                      <TableCell>{row.index}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.username}</TableCell>
                      <TableCell>{row.roles}</TableCell>
                      <TableCell>
                        <div className={style.optionsCell}>
                          <EditIcon
                            className={style.editDeleteClientButton}
                            onClick={() => onEditUser(row)}
                          />
                          <DeleteIcon
                            className={style.editDeleteClientButton}
                            onClick={() => onDeleteUser(row)}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Box>
      </div>
      <AddNewUser
        showAddUserModal={showAddUserModal}
        handleCloseAddUserModal={handleCloseAddUserModal}
        onGetUsers={onGetUsers}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setLoading={setLoading}
      />
      <DeleteUser
        showDeleteUserModal={showDeleteUserModal}
        setShowDeleteUserModal={setShowDeleteUserModal}
        onGetUsers={onGetUsers}
        setLoading={setLoading}
        userId={deleteId}
      />
      {loading ? (
        <div className={style.loading}>
          <CircularProgress color="primary" />
        </div>
      ) : (
        ""
      )}
      <ToastContainer />
    </>
  );
};
export default Users;
